import { getJson, putJson, withDone } from '@rad/utility/http';
export const getNotifications = (page, pageSize) => withDone(getJson('/api/notifications', { page, pageSize }))();
export const getUnseenCount = () => withDone(getJson('/api/notifications/unseen'))();
export const markSeen = (id) => withDone(putJson('/api/notifications/seen', { id }))();
export const markAllSeen = () => withDone(putJson('/api/notifications/seen/all', {}))();
